export default "__VITE_ASSET__0882d211__"